import React, { useContext, useRef } from "react"
import { Platform, ScrollView, View } from "react-native"
import { AddressFormFields } from "@common/components/address/AddressFormFields"
import { DimensionsContext } from "@common/utils/mobileUtils"

const SettingsAddressScreen = (props) => {
    const { control, errors } = props

    const dimensions = useContext(DimensionsContext)
    const streetRef = useRef(null)
    const complementRef = useRef(null)
    const postalCodeRef = useRef(null)
    const cityRef = useRef(null)

    return (
        <View
            style={{
                flex: 1,
                paddingTop: 0,
                width: Platform.OS === "web" ? dimensions?.width : null,
                alignSelf: "center",
            }}
        >
            <ScrollView keyboardShouldPersistTaps="handled">
                <View
                    style={{
                        marginHorizontal: 15,
                        marginTop: 20,
                    }}
                >
                    <AddressFormFields
                        control={control}
                        errors={errors}
                        spacing={10}
                        selectBoxWidth={
                            dimensions?.width < 800
                                ? dimensions?.width - 40
                                : (dimensions?.width * 3) / 4
                        }
                        streetRef={streetRef}
                        complementRef={complementRef}
                        postalCodeRef={postalCodeRef}
                        cityRef={cityRef}
                    />
                </View>
            </ScrollView>
        </View>
    )
}

export default SettingsAddressScreen
